import styled from "styled-components";
import { themes } from "../../theme/theme";

const BigBoldWhite = styled.div`
  color: ${themes.colors.colorWhite};

  position: relative;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 6.4rem;
  line-height: 132.5%;
`;
const BigTitle = styled(BigBoldWhite)`
  margin-bottom: 3rem;

  @media ${themes.device.laptopL} {
    font-size: 4.8rem;
  }
  @media ${themes.device.tabletS} {
    margin-bottom: 4rem;
  }
  @media ${themes.device.mobileM} {
    font-size: 3.2rem;
    margin-bottom: 2rem;
  }
`;
const Paragraph = styled.div`
  font-size: 2rem;
  line-height: 171.7%;
  font-weight: 300;
  color: ${themes.colors.colorGray};

  @media ${themes.device.laptopL} {
    font-size: 1.7rem;
  }

  @media ${themes.device.mobileM} {
    font-size: 1.4rem;
  }
`;
const Button = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${themes.colors.colorBlue1};
  color: ${themes.colors.colorWhite};

  transition: background 0.5s;
  font-size: 1.7rem;
  font-weight: 600;

  :hover {
    background: ${themes.colors.colorBlue2};
  }
  @media ${themes.device.laptopL} {
    font-size: 1.4rem;
  }
`;
const Spinner = styled.div`
  margin: 1rem auto;

  width: 2rem;
  height: 2rem;

  border: 2px solid ${themes.colors.colorBlue1};

  border-top: 2px solid ${themes.colors.colorWhite};
  border-radius: 100%;

  animation: spin 1s infinite linear;
`;

const Container = styled.div`
  height: auto;
  width: 100%;
  background: ${themes.colors.colorWhite};
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding: 13rem 10%;

  @media ${themes.device.laptopL} {
    padding: 13rem 15%;
  }
  @media ${themes.device.laptopS} {
    padding: 13rem 10%;
  }
  @media ${themes.device.laptop} {
    flex-direction: column;
    padding: 8rem 10%;
  }
  @media ${themes.device.tabletS} {
    padding: 8rem 5%;
  }
`;
const MainTitle = styled(BigTitle)`
  color: ${themes.colors.colorGray3};

  z-index: 20;
  font-weight: bold;
  width: 50rem;
  margin: auto;
  text-align: center;
  margin-bottom: 3rem;

  span {
    font-weight: bold;
  }
  div {
    font-weight: bold;
  }

  @media ${themes.device.tabletS} {
    font-size: 3.2rem;
    width: auto;
  }
`;

const SubtitleCustom = styled(Paragraph)`
  color: ${themes.colors.colorGray};
  z-index: 20;
  white-space: pre-wrap;
  margin-bottom: 3rem;

  text-align: center;
`;

const ButtonCustom = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${themes.colors.colorBlue1};
  color: ${themes.colors.colorWhite};
  position: relative;
  z-index: 10;
  transition: background 0.5s;
  font-size: 1.7rem;
  font-weight: 600;

  :hover {
    background: ${themes.colors.colorBlue2};
  }
  @media ${themes.device.laptopL} {
    font-size: 1.4rem;
  }

  margin-top: 2rem;
  margin-left: 1rem;

  height: 7rem;
  width: 25rem;

  @media ${themes.device.laptopL} {
    font-size: 1.4rem;

    height: 5.5rem;
    width: 20rem;
  }

  @media ${themes.device.tablet} {
    margin-top: 1rem;
  }

  @media ${themes.device.tabletS} {
    font-size: 1.4rem;
    margin-left: 0rem;
  }
`;

const AnimationDiv = styled.img`
  position: relative;
  animation: spin 20s infinite linear;

  @keyframes spin {
    from {
      transform: rotate(0deg) scale(0.9);
    }

    to {
      transform: rotate(720deg) scale(0.9);
    }
  }
  svg {
    path {
      fill: ${themes.colors.colorBlue1};
    }
  }

  @media ${themes.device.laptop} {
    transform: scale(0.9);
    @keyframes spin {
      from {
        transform: rotate(0deg) scale(0.9);
      }

      to {
        transform: rotate(720deg) scale(0.9);
      }
    }
  }
  @media (max-width: 450px) {
    @keyframes spin {
      from {
        transform: rotate(0deg) scale(1);
      }

      to {
        transform: rotate(720deg) scale(1);
      }
    }
  }
`;
const ErrorDiv = styled.div`
  color: #ec6767;
  font-weight: 300;
  font-size: 1.4rem;
  height: 1.4rem;
  transform: translate(0, -1rem);
  padding-left: 2rem;
  @media ${themes.device.tabletS} {
    padding-left: 1rem;
  }
`;
const AnimationContainer = styled.div`
  width: 45%;
  position: relative;
  height: 0;
  left: -30rem;
  top: -40rem;

  @media (max-width: 1940px) {
    width: 57%;
  }
  @media (max-width: 1680px) {
    left: -25rem;
    top: -45rem;
  }

  @media ${themes.device.laptopL} {
    width: 68%;
    left: -5rem;
    top: -60rem;
  }
  @media (max-width: 1300px) {
    width: 85%;
  }
  @media ${themes.device.laptopS} {
    width: 80%;
  }
  @media ${themes.device.laptop} {
    display: flex;
    flex-direction: column;
    align-self: center;
    width: 83%;
    left: -20rem;
  }
  @media ${themes.device.tablet} {
    width: 100%;
  }
  @media (max-width: 450px) {
    left: -5rem;
  }
`;
const InputCustom = styled.input`
  background: transparent;
  border: none;
  margin: 3rem 1rem;
  height: 5rem;
  width: 97%;
  color: ${themes.colors.mainColor};
  font-weight: 300;
  font-size: 1.7rem;
  padding-left: 1rem;

  border-bottom-width: thin;
  border-bottom-color: ${themes.colors.mainColor};
  border-bottom-style: solid;

  ::placeholder {
    color: ${themes.colors.mainColor};
    font-weight: 300;
    font-size: 1.7rem;
  }

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus,
  :-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 8rem ${themes.colors.colorWhite} inset !important;
    z-index: unset;
    -webkit-text-fill-color: ${themes.colors.mainColor};
    caret-color: ${themes.colors.mainColor};
    font-size: 1.7rem;
  }
  @media ${themes.device.tabletS} {
    width: 97%;
    margin: 1rem 0 2rem;
  }
`;

export {
  Container,
  MainTitle,
  SubtitleCustom,
  ButtonCustom,
  AnimationContainer,
  AnimationDiv,
  Button,
  ErrorDiv,
  Spinner,
  InputCustom,
};
